import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaSearch, FaTimes, FaKey } from 'react-icons/fa';

const IndstillingerBrugere = () => {
  const [brugere, setBrugere] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [passwordUser, setPasswordUser] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [passwordSaving, setPasswordSaving] = useState(false);
  const [formData, setFormData] = useState({
    brugernavn: '',
    email: '',
    rolle: 'bruger',
    name: '',
    mekaniker: false,
    crew_number: ''
  });
  const [message, setMessage] = useState('');

  const resetForm = () => {
    setFormData({
      brugernavn: '',
      email: '',
      rolle: 'bruger',
      name: '',
      mekaniker: false,
      crew_number: ''
    });
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingUser(null);
    resetForm();
  };

  const closePasswordModal = () => {
    setPasswordUser(null);
    setNewPassword('');
    setConfirmPassword('');
    setPasswordMessage('');
    setPasswordError('');
    setPasswordSaving(false);
  };

  useEffect(() => {
    fetchBrugere();
  }, []);

  const fetchBrugere = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/indstillinger/brugere', {
        headers: { 'Authorization': token ? `Bearer ${token}` : '' }
      });
      const data = await response.json();
      setBrugere(data);
    } catch (error) {
      console.error('Error fetching brugere:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editingUser ? `/api/indstillinger/brugere/${editingUser.id}` : '/api/indstillinger/brugere';
      const method = editingUser ? 'PUT' : 'POST';
      
      const token = localStorage.getItem('token');
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify(formData),
      });

        if (response.ok) {
          closeModal();
          fetchBrugere();
          setMessage(editingUser ? 'Bruger opdateret!' : 'Bruger oprettet!');
          setTimeout(() => setMessage(''), 3000);
          return;
        }

        const errorData = await response.json();
        setMessage(`Fejl: ${errorData.message}`);
    } catch (error) {
      console.error('Error saving bruger:', error);
      setMessage('Fejl ved gemning af bruger');
    }
  };

  const handleEdit = (bruger) => {
    setEditingUser(bruger);
    setFormData({
      brugernavn: bruger.brugernavn,
      email: bruger.email,
      rolle: bruger.rolle,
      name: bruger.name,
      mekaniker: bruger.mekaniker === 1,
      crew_number: bruger.crew_number || ''
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Er du sikker på, at du vil slette denne bruger?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/indstillinger/brugere/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': token ? `Bearer ${token}` : '' }
      });

      if (response.ok) {
        fetchBrugere();
        setMessage('Bruger slettet!');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      console.error('Error deleting bruger:', error);
      setMessage('Fejl ved sletning af bruger');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordMessage('');
    setPasswordError('');
    if (!newPassword || newPassword.length < 6) {
      setPasswordError('Adgangskoden skal være mindst 6 tegn');
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError('Adgangskoderne matcher ikke');
      return;
    }
    setPasswordSaving(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/indstillinger/brugere/${passwordUser.id}/password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify({ new_password: newPassword })
      });
      const data = await response.json();
      if (!response.ok) {
        setPasswordError(data?.message || 'Kunne ikke opdatere adgangskode');
        return;
      }
      setPasswordMessage('Adgangskode opdateret!');
      setTimeout(() => closePasswordModal(), 1200);
    } catch (error) {
      console.error('Error updating password:', error);
      setPasswordError('Fejl ved opdatering af adgangskode');
    } finally {
      setPasswordSaving(false);
    }
  };

  const filteredBrugere = brugere.filter(bruger =>
    bruger.brugernavn.toLowerCase().includes(searchTerm.toLowerCase()) ||
    bruger.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (bruger.name && bruger.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (bruger.crew_number && String(bruger.crew_number).toLowerCase().includes(searchTerm.toLowerCase()))
  );

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-falck-blue"></div>
      </div>
    );
  }

  return (
    <div className="px-2 sm:px-4 md:px-6 py-2 sm:py-4">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Brugere</h1>
          <p className="text-gray-600 mt-1">Administrer systemets brugere</p>
        </div>
          <button
            onClick={() => {
              setEditingUser(null);
              resetForm();
              setShowModal(true);
            }}
          className="bg-falck-blue text-white px-4 py-2 rounded-lg hover:bg-falck-dark-blue transition-colors flex items-center"
        >
          <FaPlus className="mr-2" />
          Tilføj Bruger
        </button>
      </div>

      {message && (
        <div className="mb-4 p-4 bg-blue-100 border border-blue-400 text-blue-700 rounded">
          {message}
        </div>
      )}

      {/* Søgefelt */}
      <div className="mb-6">
        <div className="relative">
          <input
            type="text"
            placeholder="Søg efter brugere..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-falck-blue"
          />
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
        </div>
      </div>

      {/* Brugere tabel */}
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg shadow overflow-hidden">
        <div className="scroll-fade-x">
          <div className="scroll-area">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-gray-900 dark:text-white">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                ID
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Brugernavn
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Rolle
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Navn
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Mandskabsnr.
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Mekaniker
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Sidste Login
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                Handlinger
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            {filteredBrugere.map((bruger) => (
              <tr key={bruger.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{bruger.id}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">
                    {bruger.brugernavn}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{bruger.email}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    bruger.rolle === 'admin' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'
                  }`}>
                    {bruger.rolle}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{bruger.name || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">{bruger.crew_number || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    bruger.mekaniker ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                  }`}>
                    {bruger.mekaniker ? 'Ja' : 'Nej'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {bruger.last_login ? new Date(bruger.last_login).toLocaleString('da-DK') : 'Aldrig'}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button
                    onClick={() => handleEdit(bruger)}
                    className="text-falck-blue hover:text-falck-dark-blue mr-3"
                    title="Rediger"
                  >
                    <FaEdit className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => setPasswordUser(bruger)}
                    className="text-gray-600 hover:text-gray-800 mr-3"
                    title="Skift adgangskode"
                  >
                    <FaKey className="h-4 w-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(bruger.id)}
                    className="text-red-600 hover:text-red-800"
                    title="Slet"
                  >
                    <FaTrash className="h-4 w-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
            </table>
          </div>
        </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 sm:py-10 overflow-y-auto">
            <div
              className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"
              aria-hidden="true"
              onClick={closeModal}
            ></div>
            <div className="relative z-10 w-full max-w-lg sm:max-w-xl border border-gray-200 dark:border-gray-700 shadow-2xl rounded-2xl bg-white dark:bg-gray-900 p-5 sm:p-6 max-h-[90vh] overflow-y-auto">
              <button
                type="button"
                onClick={closeModal}
                className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 focus:outline-none"
                aria-label="Luk"
              >
                <FaTimes className="h-4 w-4" />
              </button>
              <div className="mt-1 sm:mt-3">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
                  {editingUser ? 'Rediger bruger' : 'Tilføj ny bruger'}
                </h3>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Brugernavn
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.brugernavn}
                      onChange={(e) => setFormData({ ...formData, brugernavn: e.target.value })}
                      className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Email
                    </label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Rolle
                    </label>
                    <select
                      value={formData.rolle}
                      onChange={(e) => setFormData({ ...formData, rolle: e.target.value })}
                      className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                    >
                      <option value="bruger">Bruger</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Navn
                    </label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                      Mandskabsnummer
                    </label>
                    <input
                      type="text"
                      value={formData.crew_number}
                      onChange={(e) => setFormData({ ...formData, crew_number: e.target.value })}
                      className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                    />
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="mekaniker"
                      checked={formData.mekaniker}
                      onChange={(e) => setFormData({ ...formData, mekaniker: e.target.checked })}
                      className="h-4 w-4 text-falck-blue focus:ring-falck-blue border-gray-300 dark:border-gray-700 rounded"
                    />
                    <label htmlFor="mekaniker" className="ml-2 block text-sm text-gray-900 dark:text-gray-200">
                      Mekaniker
                    </label>
                  </div>
                  <div className="flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-3 space-y-3 sm:space-y-0 pt-4">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800"
                    >
                      Annuller
                    </button>
                    <button
                      type="submit"
                      className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-falck-blue hover:bg-falck-dark-blue"
                    >
                      {editingUser ? 'Opdater' : 'Tilføj'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
      )}

      {passwordUser && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6 sm:py-10 overflow-y-auto">
          <div
            className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm"
            aria-hidden="true"
            onClick={closePasswordModal}
          ></div>
          <div className="relative z-10 w-full max-w-md border border-gray-200 dark:border-gray-700 shadow-2xl rounded-2xl bg-white dark:bg-gray-900 p-5 sm:p-6">
            <button
              type="button"
              onClick={closePasswordModal}
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 focus:outline-none"
              aria-label="Luk"
            >
              <FaTimes className="h-4 w-4" />
            </button>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">Skift adgangskode</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
              Bruger: <span className="font-semibold">{passwordUser.brugernavn}</span>
            </p>
            <form onSubmit={handlePasswordSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                  Ny adgangskode
                </label>
                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                  Gentag adgangskode
                </label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="mt-1 block w-full border border-gray-300 dark:border-gray-700 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-falck-blue focus:border-transparent bg-white dark:bg-gray-800 dark:text-gray-100"
                />
              </div>
              {passwordMessage && (
                <div className="bg-green-50 dark:bg-green-900/40 border border-green-200 dark:border-green-800 text-green-700 dark:text-green-200 px-4 py-2 rounded-lg">
                  {passwordMessage}
                </div>
              )}
              {passwordError && (
                <div className="bg-red-50 dark:bg-red-900/40 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-200 px-4 py-2 rounded-lg">
                  {passwordError}
                </div>
              )}
              <div className="flex justify-end gap-2 pt-2">
                <button
                  type="button"
                  onClick={closePasswordModal}
                  className="px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-md text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800"
                >
                  Annuller
                </button>
                <button
                  type="submit"
                  disabled={passwordSaving}
                  className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-falck-blue hover:bg-falck-dark-blue disabled:opacity-60"
                >
                  {passwordSaving ? 'Gemmer...' : 'Gem adgangskode'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default IndstillingerBrugere;
